import React, {useEffect, useRef} from "react"
import {useLocal} from "../../AppContext"
import {hasUrlFlag, URL_FLAG__DEBUG} from "../../Helper/UrlFlag"
import style from "./CanvasCamera.css"

export const CanvasCamera = ({canvasCamera}) => {
    const map = useRef()
    const local = useLocal()
    const debug = hasUrlFlag(URL_FLAG__DEBUG)

    const onClick = () => {
        canvasCamera.next()
    }

    useEffect(() => {
        const index = canvasCamera.getCameraMapIndex()
        const currentCamera = map.current.querySelector(`g > path[class="${style.active}"]`)
        if (currentCamera) currentCamera.classList.remove(style.active)
        const newCamera = map.current.querySelector(`g > path:nth-child(${index})`)
        if (newCamera) newCamera.classList.add(style.active)
    }, [canvasCamera.getCameraIndex()])

    return <div className={style.container} onClick={onClick}>
        <div>{local.__("Kamera")} {debug && canvasCamera.getCameraIndex()}</div>
        <svg viewBox="0 0 50 50" width="100px" height="100px" ref={map}>
            {canvasCamera.getMap()}
        </svg>
    </div>
}


